import React from "react";
import "./StoreCards.scss";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";

import { customRelativeDateTime, customDayFormatter, toSafeDate } from "../logic/util";

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

// Badge label + colour, keyed off the backend's stable processingStatusKey so tooltip
// wording can change freely without affecting the badge. processingStatus is the tooltip.
// Agreed colours: pending=blue, processing results=amber, completed=green,
// deleted=grey (a normal user action, not an error - red is reserved for real
// failures), generic processing=brown (badge-brown lives in StoreCards.scss).
const STATUS_META = {
	PENDING_UPLOAD: { label: "Pending upload", cls: "badge-primary" },
	PROCESSING_RESULTS: { label: "Processing results", cls: "badge-warning" },
	COMPLETED: { label: "Completed", cls: "badge-success" },
	USER_DELETED: { label: "User deleted", cls: "badge-secondary" },
	PROCESSING: { label: "Processing", cls: "badge-brown" },
};

const statusMeta = (key) => STATUS_META[key] || STATUS_META.PROCESSING;

const StoreCards = ({ data }) => {
	let { projects, city, street, visitDateId, state, storeId, firstName, lastName } = data;

	let { relativeTime, readableTime } = customRelativeDateTime(visitDateId);
	let projectsItems = projects.map((e, i) => {
		let date = e.visitDateTime && toSafeDate(e.visitDateTime);
		let relativeTime = date && timeAgo.format(date);
		let readableTime = customDayFormatter(date).readableTime;
		let status = statusMeta(e.processingStatusKey);
		return (
			<div className='flex-space-between' key={i}>
				<span className=''>
					{e.projectName}
					<span className={`badge ${status.cls} no-help-icon ml-2`} data-help={e.processingStatus} style={{ verticalAlign: "middle" }}>
						{status.label}
					</span>
				</span>
				<span className='text-right'>
					{e.receivedImageCount} of {e.expectedImageCount} photos &nbsp;
					<span className='small text-muted no-help-icon' data-help={readableTime ? readableTime : date && date.toDateString()} style={{ whiteSpace: "nowrap" }}>
						( {relativeTime} )
					</span>
				</span>
			</div>
		);
	});

	return (
		<div className='card mb-3'>
			<div className='card-header px-2 py-2 pt-1'>
				{/* Top row: storeId on left, name on right → stack on mobile */}
				<div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center'>
					<span className='font-weight-bold h5 mb-1 mb-md-0'>{storeId}</span>
					<span className='font-weight-bold h5'>
						{firstName} {lastName}
					</span>
				</div>

				{/* Second row: address on left, time on right → stack on mobile */}
				<div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mt-1'>
					<span className='h6 text-muted mb-1 mb-md-0'>
						{street}, {city}, {state}
					</span>
					<span className='small text-muted text-md-right' style={{ whiteSpace: "nowrap" }}>
						{relativeTime} {readableTime && `, ${readableTime}`}
					</span>
				</div>
			</div>

			<div className='card-body px-2 pt-3'>
				<div className='row w-100 m-0'>
					{/* col-3 → full width on xs, 3 cols on md+ */}
					<div className='col-12 col-md-3'></div>
				</div>
				<div className='d-flex flex-column' style={{ gap: "4px" }}>
					{projectsItems}
				</div>
			</div>
		</div>
	);
};
export default StoreCards;
